import styles from "./SwapCounter.module.css";

interface SwapCounterProps {
  swapsUsed: number;
  swapsRemaining: number;
  maxSwaps: number;
  attempt?: number;
}

export function SwapCounter({
  swapsUsed,
  swapsRemaining,
  maxSwaps,
  attempt,
}: SwapCounterProps) {
  const ratio = swapsUsed / maxSwaps;
  const urgencyClass =
    ratio > 0.8 ? styles.critical : ratio > 0.6 ? styles.warning : "";

  return (
    <div className={`${styles.counter} ${urgencyClass}`}>
      <div className={styles.label}>Swaps remaining</div>
      <div className={styles.value}>
        {swapsRemaining}
        {attempt != null && attempt > 1 && (
          <span className={styles.attempt}>x{attempt}</span>
        )}
      </div>
      <div className={styles.bar}>
        <div
          className={styles.barFill}
          style={{ width: `${(swapsRemaining / maxSwaps) * 100}%` }}
        />
      </div>
    </div>
  );
}
